import { QualityRepository, UpdateQualityInput } from '../../domain/repositories/quality.repository';
import { QualityEntity } from '../../domain/entities/quality.entity';

export class UpdateQualityUseCase {
  constructor(private readonly qualityRepository: QualityRepository) {}

  async execute(id: string, input: UpdateQualityInput): Promise<QualityEntity> {
    return this.qualityRepository.updateQuality(id, input);
  }
}
